var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrchestratorsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5C10.3431 4.5 9 5.84315 9 7.5C9 9.15685 10.3431 10.5 12 10.5C13.6569 10.5 15 9.15685 15 7.5C15 5.84315 13.6569 4.5 12 4.5ZM7 7.5C7 4.73858 9.23858 2.5 12 2.5C14.7614 2.5 17 4.73858 17 7.5C17 10.2614 14.7614 12.5 12 12.5C9.23858 12.5 7 10.2614 7 7.5ZM9.92597 14.7049C10.1345 15.2163 9.889 15.7999 9.3776 16.0084C7.06131 16.953 5.5 19.0813 5.5 21.4999C5.5 22.0522 5.05228 22.4999 4.5 22.4999C3.94772 22.4999 3.5 22.0522 3.5 21.4999C3.5 18.1777 5.641 15.3723 8.6224 14.1565C9.1338 13.948 9.71743 14.1935 9.92597 14.7049Z",
    fill: "#10A37F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_792_5901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3562 20.8726L23.325 21.4267C23.0772 21.4943 22.9533 21.5282 22.8518 21.5953C22.7621 21.6548 22.6855 21.7329 22.6269 21.8246C22.5608 21.9282 22.5271 22.0551 22.4596 22.3089L21.9067 24.3888L21.3668 22.3055C21.3009 22.0513 21.2679 21.9242 21.2025 21.8202C21.1445 21.7281 21.0684 21.6495 20.979 21.5895C20.878 21.5217 20.7543 21.4871 20.5068 21.418L18.4792 20.8512L20.5103 20.297C20.7582 20.2294 20.8821 20.1956 20.9835 20.1284C21.0733 20.069 21.1499 19.9909 21.2084 19.8992C21.2746 19.7956 21.3083 19.6687 21.3758 19.4149L21.9287 17.335L22.4686 19.4183C22.5345 19.6725 22.5674 19.7996 22.6329 19.9036C22.6909 19.9957 22.767 20.0742 22.8564 20.1343C22.9574 20.2021 23.0811 20.2367 23.3285 20.3058L25.3562 20.8726Z",
    fill: "#10A37F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_792_5901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1775 21.6806L16.1206 21.9372C15.9916 21.9685 15.9271 21.9841 15.8744 22.0153C15.8277 22.0428 15.7878 22.079 15.7574 22.1215C15.723 22.1695 15.7054 22.2284 15.6704 22.346L15.383 23.3102L15.1016 22.3442C15.0673 22.2264 15.0501 22.1674 15.0161 22.1192C14.9859 22.0765 14.9463 22.0401 14.8997 22.0122C14.8471 21.9808 14.7828 21.9647 14.654 21.9326L13.5987 21.6695L14.6556 21.4129C14.7846 21.3816 14.8491 21.3659 14.9018 21.3348C14.9485 21.3073 14.9884 21.2711 15.0188 21.2286C15.0532 21.1805 15.0708 21.1217 15.1058 21.004L15.3932 20.0398L15.6745 21.0058C15.7089 21.1237 15.726 21.1826 15.7601 21.2309C15.7903 21.2736 15.8299 21.31 15.8765 21.3378C15.929 21.3693 15.9934 21.3854 16.1222 21.4175L17.1775 21.6806Z",
    fill: "#10A37F"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_792_5901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3162 16.4967L18.8241 16.8513C18.642 16.8946 18.551 16.9162 18.4765 16.9592C18.4105 16.9973 18.3543 17.0473 18.3113 17.1061C18.2628 17.1725 18.238 17.2538 18.1885 17.4164L17.7829 18.7493L17.3856 17.4139C17.3371 17.251 17.3129 17.1695 17.2648 17.1028C17.2222 17.0438 17.1662 16.9934 17.1005 16.9549C17.0263 16.9115 16.9354 16.8893 16.7536 16.8449L15.2637 16.481L16.7558 16.1264C16.9379 16.0832 17.0289 16.0615 17.1034 16.0185C17.1694 15.9804 17.2256 15.9304 17.2686 15.8717C17.3171 15.8053 17.3419 15.724 17.3914 15.5613L17.797 14.2285L18.1943 15.5638C18.2428 15.7268 18.267 15.8082 18.3151 15.8749C18.3577 15.9339 18.4137 15.9843 18.4794 16.0228C18.5536 16.0663 18.6445 16.0885 18.8263 16.1329L20.3162 16.4967Z",
    fill: "#10A37F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_792_5901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.2771,
    height: 14.7037,
    fill: "white",
    transform: "translate(26.6084 12.4092) rotate(90.1784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_792_5901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.36054,
    height: 4.77184,
    fill: "white",
    transform: "translate(17.7812 19.5024) rotate(90.1784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_792_5901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.0278,
    height: 6.73672,
    fill: "white",
    transform: "translate(21.168 13.4854) rotate(90.1784)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrchestratorsIcon);
export default __webpack_public_path__ + "static/media/OrchestratorsIcon.67ba8dcfb5a0f86a81c47e13a17a819f.svg";
export { ForwardRef as ReactComponent };